import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';

/*
This url deep links the user to the
Test payment links for payments via credit card
section of the test-payment-links KB article
*/
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const KB_ARTICLE = 'https://knowledge.hubspot.com/payments/test-payment-links#:~:text=payment%20link%20tests.-,Test%20payment%20links%20for%20payments%20via%20credit%20card,-When%20testing%2C%20you';
function TestModeAlert({
  checkoutSession
}) {
  const hasCalculateAtCheckoutTaxes = checkoutSession.isAutomatedSalesTaxEnabled;
  return /*#__PURE__*/_jsx(Alert, {
    "data-test-id": "paymentContainerAlert",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.testModeAlert.paymentContainerAlert.testCheckoutTitleText"
    }),
    type: "tip",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      gap: "200",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "100",
        as: "span",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: hasCalculateAtCheckoutTaxes ? 'payments.testModeAlert.paymentContainerAlert.astMessage' : 'payments.testModeAlert.paymentContainerAlert.message'
        })
      }), /*#__PURE__*/_jsx(Flex, {
        flexGrow: 1,
        children: /*#__PURE__*/_jsx(Button, {
          "data-tour-id": "test-checkout-onboarding-tour-second-step",
          size: "extra-small",
          href: KB_ARTICLE,
          external: true,
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'payments.testModeAlert.paymentContainerAlert.getPaymentInfo'
          })
        })
      })]
    })
  });
}
export default TestModeAlert;